import MomentUtils from "@date-io/moment";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import "./App.css";
import AppRoutes from "./AppRoutes";
import AuthContextProvider from "./Auth/AuthContextProvider";
import { AlertProvider } from "./Base/AlertProvider";
import { CssBaseline } from "@material-ui/core";

function App() {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#63316A",
      },
      secondary: {
        main: "#1B7897",
      },
      error: {
        main: "#D90000",
      },
    },
    typography: {
      h1: {
        fontSize: "1.5rem",
        fontWeight: 400,
      },
      h2: {
        fontSize: "2rem",
        fontWeight: 300,
      },
      h3: {
        fontSize: "1.5rem",
        fontWeight: 400,
      },
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          ".h3-header": {
            fontSize: "1.25rem",
            fontWeight: 500,
            marginTop: "0.5rem",
          },
        },
      },
      MuiButton: {
        outlined: {
          borderColor: "#595959",
          color: "black",
        },
        contained: {
          border: "1px solid #595959  ",
        },
      },
      MuiButtonBase: {
        root: {
          borderRadius: "4px",
          "&.Mui-focusVisible": {
            outline: "2px solid #383838",
            outlineOffset: "3px",
          },
        },
      },
      MuiCheckbox: {
        root: {
          "&.Mui-focusVisible": {
            outline: "2px solid #383838",
            outlineOffset: "-5px",
          },
        },
      },
      MuiIconButton: {
        root: {
          "&.Mui-focusVisible": {
            outline: "2px solid #383838 ",
            outlineOffset: "-6px",
          },
        },
        sizeSmall: {
          "&.Mui-focusVisible": {
            outline: "2px solid #383838 ",
            outlineOffset: "-2px",
          },
        },
      },
      MuiListItem: {
        root: {
          "&.Mui-focusVisible": {
            outline: "2px solid #383838",
            outlineOffset: "-4px",
          },
        },
      },
      MuiSelect: {
        root: {
          "&.Mui-focusVisible": {
            outline: "2px solid #383838",
            outlineOffset: "-5px",
          },
        },
      },
      MuiAlert: {
        standardSuccess: {
          backgroundColor: "#3A863D",
        },
        filledSuccess: {
          backgroundColor: "#3A863D",
          border: "1px solid #383838",
        },
        message: {
          fontWeight: 500,
        },
      },
    },
  });

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <AuthContextProvider>
          <AlertProvider>
            <AppRoutes />
          </AlertProvider>
        </AuthContextProvider>
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>
  );
}

export default App;
